// extracted by mini-css-extract-plugin
export default {"root":"PageMotherF_root__Bevz-","inner":"PageMotherF_inner__5iAnW","content":"PageMotherF_content__4jmHU","back":"PageMotherF_back__905Rh"};